import React, { Suspense, memo } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Switch, HashRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { map } from 'lodash';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import theme from '../../../shared/themes/theme';
import RouteWithSubRoutesContainer from '../../../app/containers/RouteWithSubRoutesContainer';
import NotifierContainer from '../../containers/NotifierContainer';
import store, { persistedStore } from '../../stores/store';
import appRoutes from '../../routes/appRoutes';
import styles from './root.module.scss';

export default memo(function Root() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistedStore}>
                <HashRouter>
                    <MuiThemeProvider theme={theme}>
                        <SnackbarProvider
                            action={
                                <Button
                                    aria-label="Close"
                                    className={styles.actionButton}
                                    color="inherit"
                                    key="close"
                                >
                                    <CloseIcon />
                                </Button>
                            }
                            anchorOrigin={{
                                horizontal: 'right',
                                vertical: 'top'
                            }}
                            preventDuplicate
                        >
                            <>
                                <Suspense fallback={null}>
                                    <NotifierContainer />
                                    <Switch>
                                        {map(appRoutes, (route, index) => <RouteWithSubRoutesContainer key={index} {...route} />)}
                                    </Switch>
                                </Suspense>
                            </>
                        </SnackbarProvider>
                    </MuiThemeProvider>
                </HashRouter>
            </PersistGate>
        </Provider>
    );
});
